import styled, { css } from 'styled-components';

export const MarginTop = styled.div`
  ${({ margin = '8px' }) => margin && css`
    margin-top: ${margin};
  `};
`;

export const Padding = styled.div`
  padding: 24px;
`;

